import React from 'react';
import CreateEditCategory from '../../components/manager/CreateEdit/CreateEditCategory';

/* 商品類別編輯 */
function CategoryEditPage() {

    return (
        <div className='pageContianer'>
            <CreateEditCategory typePage='EDITE'/>
        </div>
    );
}
export default CategoryEditPage;
